import { Observable, of, Subscription } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { configurationOptionActions } from '../../configuration-option/configuration-option.actions'
import { catchError, take, timeout } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { environment } from 'src/environments/environment'
import { configurationOptionSelectors } from '../configuration-option.selectors'

@Component({
  selector: 'configurationOption-create',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionCreateComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = []

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.actions$
        .pipe(ofType(configurationOptionActions.upsertMany))
        .subscribe((action) =>
          this.router.navigate([
            '/configuration-options',
            action.entities[0].id
          ])
        )
    )
  }
  public onPatch(form): void {
    this.store
      .select(configurationOptionSelectors.selectAll)

      .pipe(take(1))
      .subscribe((configOptions) => {
        if (configOptions.find((cOpt) => cOpt.key == form.key)) {
          this.store.dispatch(
            configurationOptionActions.updateOneById({
              id: configOptions.find((cOpt) => cOpt.key == form.key).id,
              params: {
                ...form,
                id: configOptions.find((cOpt) => cOpt.key == form.key).id
              }
            })
          )
        }
      })
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
  public onSubmit(form): void {
    this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(take(1))
      .subscribe((pUr) => {
        const siteId =
          pUr && pUr.siteId ? pUr.siteId : environment.defaultSiteId
        this.store.dispatch(
          configurationOptionActions.createOne({
            entity: {
              ...form,
              siteId: siteId
            }
          })
        )
      })

    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
